export const GET_OPTION_DATA_INTERVAL = 10000;
